/**
 * performs the following operations to a passed string:
 * 1. in case of a nested list inside a list item, it gets the parent list string, and excludes the nested strings separated by line break.
 * 2. transform the string to lowercase
 * 3. spaces and dashes are replaced by underscores
 * 4. removes any spaces from beginning and end of string
 * @param str
 * @returns {string}
 */
const getFormattedTrackingString = str => {
    if (str) {
        return str.split('\n')[0].toLowerCase().replace(/\s|-/g, '_').trim();
    }
    return '';
};

export { getFormattedTrackingString };
